// Desktop Événements Page - Layout 3 colonnes identique au Fil d'actualité
import React from 'react';
import UnifiedHeader from '../../components/layout/UnifiedHeader';
import MainNavigation from '../../components/layout/MainNavigation';
import { LeftSidebar, RightSidebar } from '../../components/layout/ReseauSidebars';
import MobileEvenementsPage from '../mobile/MobileEvenementsPage';

export default function DesktopEvenementsPage() {
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <UnifiedHeader />
      <MainNavigation />
      
      {/* Spacer pour compenser headers fixed */}
      <div style={{ height: '160px' }} />
      
      {/* Layout 3 colonnes */}
      <div style={{
        display: 'flex',
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '16px 24px',
        gap: '24px',
      }}>
        {/* Sidebar Gauche */}
        <LeftSidebar currentPage="evenements" />
        
        {/* Contenu Central */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '16px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            overflow: 'hidden',
          }}>
            <MobileEvenementsPage isDesktopEmbed={true} />
          </div>
        </div>
        
        {/* Sidebar Droite */}
        <RightSidebar />
      </div>
    </div>
  );
}
